import React, { useState } from 'react'
import Icon from '../icon/icon'
import styles from './wikiInfo.jcss'

export const WikiInfo = ({
    blockKey,
    blockSubKey,
    infoKey,
    size,
}: {
    blockKey: string
    blockSubKey: string
    infoKey: string
    size?: number
}) => {
    const [open, setOpen] = useState(false)
    let info: any = null
    const wiki = window.spconfig.wikiInfo

    if (
        wiki &&
        wiki[blockKey] &&
        wiki[blockKey][blockSubKey] &&
        wiki[blockKey][blockSubKey] &&
        wiki[blockKey][blockSubKey][infoKey]
    ) {
        info = wiki[blockKey][blockSubKey][infoKey]
    }

    return (
        info && (
            <>
                <div
                    onClick={() => {
                        if (info.resourceOpenType === 'external') {
                            window.open(info.url)

                            return
                        }

                        setOpen(true)
                    }}
                >
                    <Icon type={'info'} size={size ? size : 14} />
                </div>
                {open && (
                    <div className={styles.wikiModal}>
                        <Icon
                            type={'close'}
                            size={24}
                            className={styles.close}
                            color={'white'}
                            onClick={() => setOpen(false)}
                        />
                        <div className={styles.iframeWrapper}>
                            <iframe className={styles.iframe} src={info.url}></iframe>
                        </div>
                    </div>
                )}
            </>
        )
    )
}
